import type { LucideIcon } from 'lucide-react';
import { cn } from './lib/cn';

export interface Step {
  key: string;
  label: string;
  icon: LucideIcon;
}

export interface StepsProps {
  passos: readonly Step[];
  atual: number;
  onSelect: (indice: number) => void;
  /** Passo que ainda tem coisa por resolver - nao ganha o certo. */
  temPendencia?: (indice: number) => boolean;
}

/**
 * Uma trilha de passos. Cada um continua clicavel: quem sabe o que quer
 * mudar vai direto, sem repassar o formulario inteiro.
 */
export function Steps({ passos, atual, onSelect, temPendencia = () => false }: StepsProps) {
  return (
    <ol className="flex w-full items-start justify-center sm:w-auto sm:justify-start">
      {passos.map((passo, indice) => {
        // O certo e promessa de "esta resolvido": com pendencia, o passo volta
        // a mostrar o proprio icone, como antes de alguem passar por ele.
        const concluido = indice < atual && !temPendencia(indice);
        const ativo = indice === atual;
        const Icone = passo.icon;

        return (
          <li
            key={passo.key}
            // Largura fixa (w-24+) estourava a tela em celulares estreitos
            // com 4+ passos - min-w-0 flex-1 deixa cada um dividir o espaco
            // disponivel, so virando largura fixa a partir do sm.
            className="relative flex min-w-0 flex-1 flex-col items-center sm:w-32 sm:flex-none md:w-36"
          >
            {/* O tracinho encosta na bolinha e para ali: passando por baixo
                dela, o circulo virava uma conta enfiada em um fio. */}
            {indice > 0 ? (
              <span
                aria-hidden
                className="absolute left-0 right-[calc(50%+1.5rem)] top-6 h-px bg-border-strong"
              />
            ) : null}
            {indice < passos.length - 1 ? (
              <span
                aria-hidden
                className="absolute left-[calc(50%+1.5rem)] right-0 top-6 h-px bg-border-strong"
              />
            ) : null}

            <button
              type="button"
              onClick={() => onSelect(indice)}
              aria-current={ativo ? 'step' : undefined}
              className="relative flex flex-col items-center gap-1.5 px-1"
            >
              <span
                className={cn(
                  'flex h-12 w-12 items-center justify-center rounded-full border transition-colors',
                  ativo && 'border-primary-foreground/30 bg-primary text-primary-foreground',
                  concluido && 'border-primary/30 bg-primary/10 text-primary',
                  !ativo && !concluido && 'border-border-strong bg-card text-muted-foreground',
                )}
              >
                <Icone className="h-5 w-5" />
              </span>

              <span
                className={cn(
                  'break-words text-center text-[13px] leading-tight',
                  ativo ? 'font-medium text-foreground' : 'text-muted-foreground',
                )}
              >
                {passo.label}
              </span>
            </button>
          </li>
        );
      })}
    </ol>
  );
}
